import { Card, CircularProgress } from "@mui/material";
import ImagePicker from "components/ApnaUploader";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import AstrieskIcon from "components/AstrieskIcon";
import PropTypes from "prop-types";

import React, { useEffect, useState } from "react";
import { getGlobalCategory } from "redux/festures/categorySlice";
import { useDispatch, useSelector } from "react-redux";
import { creatCategoryData } from "redux/festures/categorySlice";
import { handleAlert } from "redux/festures/alertSlice";
import { updateCategory } from "redux/festures/categorySlice";
import { Cancel } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import { getCategory } from "redux/festures/categorySlice";
import { unlinkImage } from "redux/festures/categorySlice";

const getInitialProfile = () => ({
  categoryName: "",
  uploadPic: "",
  bannerImage: "",
  bannerVideo: "",
  cityId: [],
  categoryId: "",
  category__Id: "",
  isShow: "",
  serverBannerImage: null,
  adminCommission: "",
  size: [],
});

const PcatogeroyUpdate = ({ viewData, isPUpdates, setIsOpenUpdate,filter }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const dispatch = useDispatch();

  

  const admin = localStorage.getItem("admin_id");

  const [profile, setProfile] = useState(getInitialProfile());
  const [sizeInput, setSizeInput] = useState("");
  const [adminCommissionError, setAdminCommissionError] = useState("");

  const {
    Loading,
    category,
    subCategory,
    IsLoading,
    isPages,
    subCategoryData,
    createUpdateLoading,
  } = useSelector((state) => ({
    ...state.isCategory,
  }));
const adminId = localStorage.getItem("admin_id");




  useEffect(() => {
    if (viewData && isPUpdates) {
      setProfile({
        categoryName: viewData?.name || "",
        uploadPic: "",
        bannerImage: "",
        bannerVideo: "",
        // cityId: viewData?.cityId?.length ? viewData?.cityId?.map((ele) => ele?._id) : [],
        categoryId: viewData?._id || "",
        category__Id: "",
        isShow: viewData?.icon || "",
        serverBannerImage: viewData?.banner?.length
          ? viewData?.banner?.filter((ele) => ele?.type === "IMAGE")
          : null,
        adminCommission:
          viewData?.adminCommission !== undefined && viewData?.adminCommission !== null
            ? String(viewData?.adminCommission)
            : "",
        size: Array.isArray(viewData?.size) ? viewData?.size?.filter(Boolean) : [],
      });
    } else {
      setProfile(getInitialProfile());
    }
    setSizeInput("");
    setAdminCommissionError("");
  }, [viewData, isPUpdates]);

  const handleAdminCommissionChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      setAdminCommissionError("");
      setProfile((prev) => ({
        ...prev,
        adminCommission: "",
      }));
      return;
    }

    if (!/^\d{0,3}(\.\d{0,2})?$/.test(value)) return;

    const numericValue = Number(value);
    setAdminCommissionError(numericValue > 100 ? "Admin commission cannot be more than 100%." : "");
    setProfile((prev) => ({
      ...prev,
      adminCommission: value,
    }));
  };

  const handleAddSize = () => {
    const formattedSize = sizeInput.trim();
    if (!formattedSize) return;

    setProfile((prev) => ({
      ...prev,
      size: prev?.size?.includes(formattedSize) ? prev.size : [...prev.size, formattedSize],
    }));
    setSizeInput("");
  };

  const handleRemoveSize = (sizeValue) => {
    setProfile((prev) => ({
      ...prev,
      size: prev.size.filter((item) => item !== sizeValue),
    }));
  };

  const handleSubmitCategory = (e) => {
    e.preventDefault();
    const trimmedCommission = profile?.adminCommission?.toString()?.trim();
    const numericCommission = Number(trimmedCommission);

    if (
      trimmedCommission !== "" &&
      (Number.isNaN(numericCommission) || numericCommission > 100 || numericCommission < 0)
    ) {
      setAdminCommissionError("Admin commission must be between 0 and 100.");
      return;
    }

    const formData = new FormData();
    formData.append("name", profile.categoryName);
    if (profile?.uploadPic) formData.append("icon", profile.uploadPic);
    if (profile?.bannerImage && profile?.bannerImage?.length)
      profile?.bannerImage?.map((e) => formData.append("banner", e));
    if (profile?.bannerVideo) formData.append("banner", profile?.bannerVideo);
    if (trimmedCommission !== "") formData.append("adminCommission", trimmedCommission);
    profile?.size?.forEach((value, index) => formData.append(`size[${index}]`, value));

    dispatch(
      isPUpdates
        ? updateCategory({
            url: `/eCommerce/updateCategory/${profile?.categoryId}/${admin}`,
            data: formData,
          })
        : creatCategoryData({
            url: `/eCommerce/createCategory/${admin}`,
            reqBody: formData,
          })
    ).then((data) => {
      dispatch(
        handleAlert({
          isOpen: true,
          type: `${data?.payload?.success ? "success" : "error"}`,
          msg: data?.payload?.message,
        })
      );
      if (data?.payload?.success) {
        setProfile(getInitialProfile());
        setSizeInput("");
        setAdminCommissionError("");

        dispatch(
  getGlobalCategory({
    adminId: adminId,
    filter: filter,
    page: 1
  })
);

        setIsOpenUpdate(false);
      }
    });
  };
  return (
    <MDBox
      display="flex"
      alignItems="center"
      lineHeight={1}
      sx={({ palette: { dark, white, info } }) => ({
        border: 0.5,
        borderColor: darkMode ? white.main : dark.main,
        borderRadius: 3,
        p: 2,
        width: "100%",
        //   height: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 2,
      })}
    >
      <Card
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 , 10px",
        }}
      >
        <MDTypography variant="h6" py={0.9}>
          {isPUpdates ? " Update Category " : "Create Category Ecom"}
        </MDTypography>
      </Card>

      <MDBox
        display="flex"
        alignItems="center"
        lineHeight={1}
        sx={{
          justifyContent: "center",
          textAlign: "center",
          flexDirection: "column",
          gap: 2,
          width: "100%",
        }}
        component="form"
        role="form"
        onSubmit={handleSubmitCategory}
      >
        <MDBox
          display="flex"
          alignItems="flex-start"
          flexDirection="column"
          lineHeight={1}
          gap={3}
          width={"75%"}
        >
          <MDTypography variant="h6">
            Category Name <AstrieskIcon />
          </MDTypography>
          <MDInput
            disabled={createUpdateLoading}
            required={true}
            placeholder="category name"
            type="text"
            fullWidth
            pl={3}
            value={profile.categoryName}
            onChange={(e) => {
              setProfile((prev) => ({
                ...prev,
                categoryName: e.target.value,
              }));
            }}
          />
        </MDBox>

        <MDBox
          display="flex"
          alignItems="flex-start"
          flexDirection="column"
          lineHeight={1}
          gap={3}
          width={"75%"}
        >
          <MDTypography variant="h6">
            Category Image <AstrieskIcon />
            <MDTypography variant="body1" component="span" fontSize={11}>
              &nbsp; ( image size - 178 × 178 px )
            </MDTypography>
          </MDTypography>
          <ImagePicker
            disabled={createUpdateLoading}
            // required={true}
            name="Image"
            multiple={false}
            images={profile?.uploadPic}
            setImages={(e) => {
              setProfile((prev) => ({
                ...prev,
                uploadPic: e,
              }));
            }}
          />

          {profile?.uploadPic === "" && profile?.isShow && (
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <span
                style={{
                  display: "inline-block",
                  width: "50px",
                  height: "50px",
                  margin: "0 0.5rem",
                }}
              >
                <img
                  className="Image"
                  style={{ width: "100%", height: "100%" }}
                  src={`${process.env.REACT_APP_URI}/${profile?.isShow}`}
                />
              </span>
              <span
                className="cross"
                style={{
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  setProfile((prev) => ({
                    ...prev,
                    uploadPic: "",
                  }));
                }}
              >
                <Cancel
                  sx={({ palette: { dark, white, info } }) => ({
                    color: darkMode ? white?.main : dark.main,
                  })}
                />
              </span>
            </div>
          )}
        </MDBox>

        <MDBox
          display="flex"
          alignItems="flex-start"
          flexDirection="column"
          lineHeight={1}
          gap={1.5}
          width={"75%"}
        >
          <MDTypography variant="h6">
            Admin Commission (%) <AstrieskIcon />
          </MDTypography>
          <MDInput
            disabled={createUpdateLoading}
            required={true}
            placeholder="Enter admin commission"
            type="number"
            fullWidth
            value={profile.adminCommission}
            onChange={handleAdminCommissionChange}
            inputProps={{ min: 0, max: 100, step: "0.01" }}
          />
          {adminCommissionError ? (
            <MDTypography variant="caption" color="error">
              {adminCommissionError}
            </MDTypography>
          ) : (
            <MDTypography variant="caption" color="text">
              Maximum allowed value is 100.
            </MDTypography>
          )}
        </MDBox>

        <MDBox
          display="flex"
          alignItems="flex-start"
          flexDirection="column"
          lineHeight={1}
          gap={1.5}
          width={"75%"}
        >
          <MDTypography variant="h6">Size</MDTypography>
          <MDBox
            sx={{
              width: "100%",
              display: "flex",
              gap: 1.5,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <MDBox sx={{ flex: 1, minWidth: 220 }}>
              <MDInput
                disabled={createUpdateLoading}
                placeholder="Add size like S, M, L"
                type="text"
                fullWidth
                value={sizeInput}
                onChange={(e) => setSizeInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleAddSize();
                  }
                }}
              />
            </MDBox>
            <MDButton
              color="info"
              variant="outlined"
              onClick={handleAddSize}
              disabled={createUpdateLoading || !sizeInput.trim()}
            >
              Add Size
            </MDButton>
          </MDBox>

          {profile?.size?.length ? (
            <MDBox
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                width: "100%",
              }}
            >
              {profile?.size?.map((item) => (
                <MDBox
                  key={item}
                  sx={({ palette: { grey, white, dark } }) => ({
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    px: 1.5,
                    py: 0.8,
                    borderRadius: 2,
                    backgroundColor: darkMode ? grey[900] : grey[200],
                    color: darkMode ? white.main : dark.main,
                  })}
                >
                  <MDTypography variant="button">{item}</MDTypography>
                  <Cancel
                    fontSize="small"
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleRemoveSize(item)}
                  />
                </MDBox>
              ))}
            </MDBox>
          ) : (
            <MDTypography variant="caption" color="text">
              Add one or more size values. These will be sent as a string array.
            </MDTypography>
          )}
        </MDBox>
        {/* <MDBox
          display="flex"
          alignItems="flex-start"
          flexDirection="column"
          lineHeight={1}
          gap={3}
          width={"75%"}
        >
          <MDTypography variant="h6">
            Category Banner Image{" "}
            <MDTypography variant="body1" component="span" fontSize={11}>
              &nbsp; ( image size - 178 × 178 px )
            </MDTypography>
          </MDTypography>
          <ImagePicker
            disabled={createUpdateLoading}
            // required={!profile?.bannerVideo}
            name="bannerImage"
            multiple={true}
            images={profile?.bannerImage}
            setImages={(e) => {
              setProfile((prev) => ({
                ...prev,
                bannerImage: e,
              }));
            }}
            //
          />
          {profile?.serverBannerImage && profile?.serverBannerImage?.length ? (
            <div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
              {" "}
              {profile?.serverBannerImage?.map((ele, i) => (
                <span style={{ display: "flex", alignItems: "flex-start" }} key={i}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "50px",
                      height: "50px",
                      margin: "0 0.5rem",
                    }}
                  >
                    <img
                      className="Image"
                      style={{ width: "100%", height: "100%" }}
                      src={`${process.env.REACT_APP_URI}/${ele?.url}`}
                    />
                  </span>
                  <span
                    className="cross"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      dispatch(
                        unlinkImage({
                          url: `/unLinks/${profile?.categoryId}/${admin}`,
                          data: { imageIndex: i + 1 },
                          notFormData: true,
                        })
                      ).then((data) => {
                        if (data?.payload?.success) {
                          const temp = [...profile?.serverBannerImage];
                          temp.splice(i, 1);
                          setProfile((prev) => ({
                            ...prev,
                            serverBannerImage: temp,
                          }));
                          dispatch(
                            handleAlert({
                              isOpen: true,
                              type: `${data.payload.success ? "success" : "error"}`,
                              msg: data.payload.message,
                            })
                          );
                        }
                      });
                    }}
                  >
                    <Cancel
                      sx={({ palette: { dark, white, info } }) => ({
                        color: darkMode ? white?.main : dark.main,
                      })}
                    />
                  </span>
                </span>
              ))}
            </div>
          ) : null}
        </MDBox> */}

        <MDBox
          sx={{ width: "100%", justifyContent: "flex-end", textAlign: "center", display: "flex" }}
        >
          <MDButton color={"info"} verdant={"gradient"} type={"submit"}>
            {createUpdateLoading ? (
              <CircularProgress color="primary" size={20} />
            ) : isPUpdates ? (
              " Update Category "
            ) : (
              "Create Category"
            )}
          </MDButton>
        </MDBox>
      </MDBox>
    </MDBox>
  );
};

export default PcatogeroyUpdate;

PcatogeroyUpdate.propTypes = {
  viewData: PropTypes.any,
  isPUpdates: PropTypes.bool,
  filter: PropTypes.bool,
  setIsOpenUpdate: PropTypes.func,
};
